import React from 'react';

interface NotificationBellProps {
  active?: boolean;
}
const NotificationBell = ({ active }: NotificationBellProps) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6705 13.0492C15.2803 12.377 14.7002 10.475 14.7002 7.99091C14.7002 6.49906 14.1075 5.06832 13.0526 4.01343C11.9978 2.95854 10.567 2.36591 9.07517 2.36591C7.58333 2.36591 6.15259 2.95854 5.0977 4.01343C4.04281 5.06832 3.45017 6.49906 3.45017 7.99091C3.45017 10.4757 2.86939 12.377 2.47916 13.0492C2.3795 13.2201 2.32667 13.4142 2.326 13.612C2.32532 13.8099 2.37681 14.0044 2.47529 14.1759C2.57377 14.3475 2.71575 14.4901 2.8869 14.5893C3.05806 14.6885 3.25235 14.7408 3.45017 14.7409H6.31963C6.4494 15.3759 6.79453 15.9467 7.29664 16.3565C7.79875 16.7664 8.42702 16.9903 9.07517 16.9903C9.72333 16.9903 10.3516 16.7664 10.8537 16.3565C11.3558 15.9467 11.7009 15.3759 11.8307 14.7409H14.7002C14.8979 14.7406 15.0921 14.6882 15.2632 14.589C15.4343 14.4898 15.5761 14.3472 15.6745 14.1756C15.7729 14.0041 15.8244 13.8096 15.8236 13.6119C15.8229 13.4141 15.7701 13.22 15.6705 13.0492ZM9.07517 15.8659C8.7263 15.8658 8.38603 15.7576 8.1012 15.5561C7.81638 15.3546 7.601 15.0698 7.4847 14.7409H10.6656C10.5493 15.0698 10.334 15.3546 10.0491 15.5561C9.76432 15.7576 9.42405 15.8658 9.07517 15.8659Z"
        fill={active ? '#FFFFFF' : '#5C6469'}
      />
    </svg>
  );
};

export default NotificationBell;
